module.exports = __webpack_public_path__ + "img/climate_actions_greenenergy.71082e2.svg";